import { render, staticRenderFns } from "./enum-form.vue?vue&type=template&id=33cab874&scoped=true&"
import script from "./enum-form.vue?vue&type=script&lang=js&"
export * from "./enum-form.vue?vue&type=script&lang=js&"
import style0 from "./enum-form.vue?vue&type=style&index=0&id=33cab874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cab874",
  null
  
)

export default component.exports